/**
 * phone-identifier-challenge/index.tsx
 *
 * WHAT THIS SCREEN DOES
 * ---------------------
 * Prompts the user to enter the SMS or WhatsApp code sent to their phone
 * during a passwordless or multi-factor authentication flow.
 */

import { AuthLayout } from "@/components/auth/AuthLayout";
import { applyAuth0Theme } from "@/utils/theme";

import PhoneIdentifierChallengeForm from "./components/PhoneIdentifierForm";
import { usePhoneIdentifierChallengeManager } from "./hooks/usePhoneIdentifierChallengeManager";

function PhoneIdentifierChallengeScreen() {
  const { phoneIdentifierChallenge, texts, locales } =
    usePhoneIdentifierChallengeManager();

  document.title =
    texts?.pageTitle || locales?.pageTitle || "Verify your phone";
  applyAuth0Theme(phoneIdentifierChallenge);

  const handleBack = () => {
    // Auth0 ACUL fallback for returning to the identifier entry screen
    window.history.back();
  };

  return (
    <AuthLayout title={texts?.title || locales?.title || "Check your phone"}>
      <PhoneIdentifierChallengeForm onBack={handleBack} />
    </AuthLayout>
  );
}

export default PhoneIdentifierChallengeScreen;
